<h1 i18n="@@upp.hotels.create.title">Create Hotel Rule</h1>

<div class="container-fluid">
  <ama-loading-alert [sendingStatus]="sendingStatus" message="Loading..." i18n-message="@@upp.global.messages.loading">
  </ama-loading-alert>
</div>

<ama-upp-notification
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
  (openDisplayEvent)="showHotelRuleInDisplay()"
>
</ama-upp-notification>

@if(hotelsV2) {
<app-hotel-details-v2
  [hotelDetailsForm]="hotelForm!"
  [hotelDetails]="hotelRule"
  [readonly]="readonly"
  [viewMode]="currentViewMode"
>
</app-hotel-details-v2>
} @else {
<ama-ng-upp-hotel-details
  [hotelDetailsForm]="hotelForm!"
  [hotelDetails]="hotelRule"
  [readonly]="readonly"
  [parent]="uppComponent"
>
</ama-ng-upp-hotel-details>
}

<div class="d-flex justify-content-end">
  @if (!sendingStatus) {
  <button
    i18n="@@upp.global.button.save"
    type="submit"
    class="btn btn-primary mb-2 mb-md-0 me-2"
    [disabled]="!hotelsV2 && !saveButtonEnabled()"
    (click)="saveData()"
    data-test="save-data-button"
  >
    Save
  </button>
  } @if (sendingStatus) {
  <button
    i18n="@@upp.global.button.save"
    type="button"
    disabled
    class="btn btn-primary mb-2 mb-md-0 me-2"
    data-test="save-data-button"
  >
    Save
  </button>
  }
</div>
